type ToastType = 'info' | 'success' | 'error';

const CONTAINER_ID = 'wesaves-toast-container';

const typeStyles: Record<ToastType, string> = {
  info: 'bg-slate-900 text-white',
  success: 'bg-green-600 text-white',
  error: 'bg-red-600 text-white',
};

const ensureContainer = (): HTMLElement | null => {
  if (typeof document === 'undefined') return null;
  let el = document.getElementById(CONTAINER_ID);
  if (el) return el;

  el = document.createElement('div');
  el.id = CONTAINER_ID;
  el.className = 'fixed top-4 right-4 z-[9999] flex w-[calc(100vw-1.5rem)] max-w-sm flex-col gap-2 pointer-events-none';
  document.body.appendChild(el);
  return el;
};

export const showToast = (message: string, type: ToastType = 'info', durationMs = 3200) => {
  const container = ensureContainer();
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = `pointer-events-auto rounded-xl px-3 py-2 text-sm font-semibold shadow-xl break-words ${typeStyles[type]}`;
  toast.textContent = message;
  toast.style.opacity = '0';
  toast.style.transform = 'translateY(-6px)';
  toast.style.transition = 'opacity 180ms ease, transform 180ms ease';

  container.appendChild(toast);
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  window.setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-6px)';
    window.setTimeout(() => toast.remove(), 220);
  }, durationMs);
};

